module.exports = __webpack_public_path__ + "first-20_back.jpg?b187a8fd12948c517b60d7cc8681e9d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_back.jpg
// module id = 496
// module chunks = 0